import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../actions";
import { DataTable } from "../../../../components/data-table";
import { Modal } from "flowbite-react";
import { FlatButton } from "../../../../components/buttons";

function AgentSetupModal({ company_uid, isOpen, onClose, onConfirm }) {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.company.users);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const urlParams = useRef({});
  
  useEffect(() => {
    if (isOpen && company_uid) {
      // Fetch users when modal opens
      handleFetch();
    }
  }, [isOpen, company_uid]);

  const handleFetch = async (params) => {
    if (company_uid) {
      urlParams.current.company_uid = company_uid;
      if (params) {
        urlParams.current.page = params.page;
        urlParams.current.count = params.pageLimit;
        urlParams.current.sort_by = params.sortBy;
        urlParams.current.sort = params.sortDir;
        urlParams.current["filter.keyword"] = params.keyword;
      }
      dispatch(actions.GETCOMPANYUSER_REQ(urlParams.current));
    }
  };

  const handleConfirm = () => {
    onConfirm(selectedAgents);
    onClose();
  };

  const handleCancel = () => {
    setSelectedAgents([]);
    onClose();
  };


  const columns = [
    {
      name: "Employee Code",
      key: "emp_code",
    },
    {
      name: "Name",
      key: "first_name",
      formatText: (_, data) =>
        data.first_name + " " + data.last_name,
    },
    { name: "Email", key: "email", width: "48" },
    {
      name: "Role",
      key: "role.role_name",
      formatText: (_, data) => data.role.role_name,
    },
    {
      name: "Status",
      key: "is_active",
      width: "20",
      formatText: (isActive, row) =>
        row.is_deleted ? "Deleted" : isActive ? "Active" : "Inactive",
      processClassName: (isActive, row) =>
        row.is_deleted
          ? "text-red-500 font-medium"
          : isActive
            ? "text-green-500 font-medium"
            : "text-red-500 font-medium",
    },
  ];

  return (
    <Modal show={isOpen} size="5xl" onClose={handleCancel}>
      <Modal.Body>
        <div className="min-h-50 [&>div]:p-0">
          <DataTable
            name="Select Agents"
            columns={columns}
            remote={true}
            data={users?.data || []}
            totalCount={users?.total_records || 0}
            indexField="user_uid"
            handleFetch={handleFetch}
            toolbar={{
              search: { enable: true, placeholder: "Search users..." },
            }}
            footer={{
              paginator: { enable: true, limits: [10], placement: "start" },
              customActions: (
                <div className=" justify-self-end flex flex-row gap-x-6">
                  <FlatButton
                    size="xl"
                    appearance="secondary"
                    id="cancel-button"
                    onClick={handleCancel}
                  >
                    Cancel
                  </FlatButton>
                  <FlatButton
                    size="xl"
                    disabled={selectedAgents?.length === 0}
                    appearance="primary"
                    // className={confirmClass || ""}
                    id="confirm-button"
                    onClick={handleConfirm}
                  >
                    Confirm
                  </FlatButton>
                </div>
              )
            }}
            rowSelection={{
              enable: true,
              type: "selection",
              position: "end",
              multi: true,
              selected: selectedAgents,
              onRowSelect: ({ selectedRows }) => {
                setSelectedAgents(selectedRows);
              },
            }}
          />
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <div className="flex w-full justify-end gap-3">
          <FlatButton
            appearance="secondary"
            onClick={handleCancel}
            className="w-[100px]"
          >
            Cancel
          </FlatButton>
          <FlatButton
            onClick={handleConfirm}
            disabled={selectedAgents.length === 0}
            className="w-[100px]"
          >
            Confirm
          </FlatButton>
        </div>
      </Modal.Footer> */}
    </Modal>
  );
}

export default AgentSetupModal;
